import { Component } from "react";
import PropTypes from "prop-types";

import _ from "underscore";

import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { paidOut, exported, fullyPaid } from "../Loans.Helper";
import ClaimsWrapper from "../../../shared/ui/Claim.Wrapper";
import { allClaimsOtherThanAml } from "../../../shared/ClaimLists/Claim.Aml.All.List";

export default class LoanTableButtons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPaidOut: paidOut.all,
      selectedExported: exported.all,
      selectedFullyPaid: fullyPaid.all,
    };
  }

  handleTypeChange = (name, event) => {
    this.setState({ [name]: event.target.value, stateChanged: true });
  };

  soSomething = () => {
    let selected = [];
    // EMPTY for now
    selected = this.props.getSelected();

    let selectedId = _.pluck(selected, "Id");

    var token = JSON.parse(localStorage.getItem("admin.usr"))["access_token"];
    var req = new XMLHttpRequest();
    req.open("POST", "/api/admin/autogiro/files/payments", true);
    req.responseType = "blob";
    req.setRequestHeader("Authorization", "Bearer " + token);
    req.setRequestHeader("Content-Type", "application/json");
    req.onload = () => {
      var blob = req.response;
      var fileName = "BFEP.IAGAG.537531.180703.133827";
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    };
    req.send(JSON.stringify(selectedId));
  };

  getTerminated = () => {
    let selected = [];
    // EMPTY for now
    selected = this.props.getSelected();
    let selectedIds = _.pluck(selected, "Id");
    let creditIds = { Creditids: selectedIds };

    var token = JSON.parse(localStorage.getItem("admin.usr"))["access_token"];
    var req = new XMLHttpRequest();
    req.open("POST", "/api/admin/credits/terminated/report", true);
    req.responseType = "blob";
    req.setRequestHeader("Authorization", "Bearer " + token);
    req.setRequestHeader("Content-Type", "application/json");
    req.onload = () => {
      var blob = req.response;
      var fileName = "terminated.csv";
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    };
    req.send(JSON.stringify(creditIds));
  };

  searchWithParams = () => {
    this.props.getLoans(
      this.props.accountId,
      this.state.selectedPaidOut,
      this.state.selectedExported,
      this.state.selectedFullyPaid,
    );
  };

  render() {
    return (
      <div>
        <ClaimsWrapper claimAuth={allClaimsOtherThanAml}>
          <Button
            variant="contained"
            color="primary"
            onClick={this.soSomething}
          >
            Get autogiro file
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={this.getTerminated}
            style={{ margin: "0 10px" }}
          >
            Terminated loans file
          </Button>
        </ClaimsWrapper>

        <p />
        <div style={{ padding: "16px" }}>
          <p>
            Autogiro file will be generated for ALL loans <b>EXCEPT</b> the ones
            that are selected Termianted loans file renerates file for all{" "}
            <b>SELECTED</b> loans
          </p>

          <div style={{ display: "flex" }}>
            <div>
              Paid Out
              <br />
              <TextField
                size="small"
                variant="outlined"
                select
                value={this.state.selectedPaidOut}
                onChange={this.handleTypeChange.bind(this, "selectedPaidOut")}
              >
                <MenuItem value={paidOut.all}>All</MenuItem>
                <MenuItem value={paidOut.onlyPaidOut}>Only paid out</MenuItem>
                <MenuItem value={paidOut.onlyNotPaidOut}>
                  Only not paid out
                </MenuItem>
              </TextField>
            </div>

            <div>
              Exported
              <br />
              <TextField
                size="small"
                variant="outlined"
                select
                value={this.state.selectedExported}
                onChange={this.handleTypeChange.bind(this, "selectedExported")}
              >
                <MenuItem value={exported.all}>All</MenuItem>
                <MenuItem value={exported.onlyExported}>Only exported</MenuItem>
                <MenuItem value={exported.onlyNotExported}>
                  Only not exported
                </MenuItem>
              </TextField>
            </div>

            <div>
              Fully paid
              <br />
              <TextField
                size="small"
                variant="outlined"
                select
                value={this.state.selectedFullyPaid}
                onChange={this.handleTypeChange.bind(this, "selectedFullyPaid")}
              >
                <MenuItem value={fullyPaid.all}>All</MenuItem>
                <MenuItem value={fullyPaid.onlyFullyPaid}>
                  Only fully paid
                </MenuItem>
                <MenuItem value={fullyPaid.onlyNotFullyPaid}>
                  Only not fully paid
                </MenuItem>
              </TextField>
            </div>
          </div>

          <Button
            variant="contained"
            color="primary"
            onClick={this.searchWithParams}
            style={{ margin: "0 0px" }}
          >
            Filter loans
          </Button>
        </div>
      </div>
    );
  }

  static propTypes = {
    getLoans: PropTypes.func,
  };
}
